class AbortablePromise {
  constructor(executor, signal) {
    this.signal = signal;
    if (typeof executor !== "function") {
      this.source = Promise.resolve(executor);
    } else if (signal?.aborted) {
      this.source = Promise.reject(signal.reason);
    } else {
      this.source = Promise.resolve().then(executor);
    }
  }
  /**
   * source 를 abort 와 경쟁시킨 promise. 실제로 소비될 때(then/toPromise) 한 번만 만든다 —
   * await 는 then() 이 돌려준 새 인스턴스를 버리므로, 미리 만들면 아무도 안 받는 reject 가 unhandled 로 남는다.
   */
  get promise() {
    if (this.guarded) return this.guarded;
    const signal = this.signal;
    if (!signal) return this.guarded = this.source;
    if (signal.aborted) {
      this.source.catch(() => {
      });
      return this.guarded = Promise.reject(signal.reason);
    }
    return this.guarded = new Promise((resolve, reject) => {
      const cleanup = () => signal.removeEventListener("abort", onAbort);
      const onAbort = () => reject(signal.reason);
      signal.addEventListener("abort", onAbort, { once: true });
      this.source.then(
        (value) => {
          cleanup();
          resolve(value);
        },
        (reason) => {
          cleanup();
          reject(reason);
        }
      );
    });
  }
  then(onfulfilled, onrejected) {
    const signal = this.signal;
    const next = this.promise.then(
      onfulfilled ? (value) => {
        if (signal?.aborted) throw signal.reason;
        return onfulfilled(value);
      } : void 0,
      onrejected
    );
    return new AbortablePromise(next, signal);
  }
  catch(onrejected) {
    return this.then(void 0, onrejected);
  }
  finally(onfinally) {
    return new AbortablePromise(this.promise.finally(onfinally), this.signal);
  }
  // 네이티브 Promise 로 변환 (그냥 await 해도 된다)
  toPromise() {
    return this.promise;
  }
}
export {
  AbortablePromise
};
//# sourceMappingURL=AbortablePromise.js.map
